<template>
  <main class="bg-white">
    <v-container fluid class="pa-0 licence">
      <v-toolbar flat class="main-header main-header__shadow mb-6 px-5 py-2">
        <v-toolbar-title class="main-header__title">
          <h1>
            <v-icon class="mx-3 mb-1" @click="back">mdi-arrow-left</v-icon
            >{{ $t("honor-plates") }}
          </h1>
        </v-toolbar-title>

        <v-spacer></v-spacer>
        <v-toolbar-items class="main-header__contents">
          <v-btn
            class="my-auto mx-1 radius-12 text-capitalize"
            color="success"
            to="/honor-plates/create"
          >
            <v-icon>mdi-plus</v-icon>
            <span class="mx-2">{{ $t("add_honor_plates") }}</span>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <wrapping-table
        :headersName="headers"
        pathName="honor-plates"
        ref="table_ref"
      >
        <template slot-scope="{ item, index }">
          <td class="table__cell text-center">
            <read-more
              more-str="more"
              less-str="less"
              :max-chars="15"
              :text="item.name || '---'"
              class="mb-0 major-description m-b-0"
            ></read-more>
          </td>
          <td class="table__cell text-center">
            {{ item.degree_level.name }}
          </td>
          <td class="table__cell text-center">
            <read-more
              more-str="more"
              less-str="less"
              :max-chars="15"
              :text="item.title || '---'"
              class="mb-0 major-description m-b-0"
            ></read-more>
          </td>

          <td class="table__cell text-center">
            <strong class="err" v-if="item.visible"
              ><v-icon color="success">mdi-check-circle</v-icon></strong
            >
            <strong v-else
              ><v-icon color="error">mdi-close-circle</v-icon></strong
            >
          </td>
          <td class="table__cell text-center">
            <v-btn :to="`/honor-plates/${item.slug}/contacts`" icon>
              <v-icon>mdi-contacts</v-icon>
            </v-btn>
          </td>
          <td
            class="table__cell text-center d-flex align-center justify-center"
          >
            <v-btn icon small :to="`/honor-plates/${item.slug}/edit`"
              ><v-icon small color="primary">mdi-pencil</v-icon></v-btn
            >
            <v-btn icon small>
              <v-icon
                color="error"
                class="delete"
                small
                @click="$refs.table_ref.handleDelete(item.slug, index)"
              >
                mdi-delete
              </v-icon></v-btn
            >
          </td>
        </template>
      </wrapping-table>
    </v-container>
  </main>
</template>
<script>
export default {
  name: "subjects",
  data() {
    return {
      headers: [
        "name",
        "degree_level",
        "title",
        "visible",
        "contacts",
        "actions",
      ],
    };
  },

  methods: {
    back() {
      history.go(-1);
    },
  },
};
</script>
